<div class="date-range-input d-flex align-items-center pl-3" #dateRangeInput>
  <ng-container *ngIf="selectedRangeValueSubject | async as selectedRangeValue">
    <div class="text-center">
      {{ formatDates(selectedRangeValue) }}
    </div>
  </ng-container>
  <mat-datepicker-toggle
    matSuffix
    class="ml-auto"
    (click)="openDatePickerDialog(datePickerDialog)"
  ></mat-datepicker-toggle>
</div>
<ng-template #datePickerDialog>
  <div mat-dialog-content class="mh-100 p-0">
    <mat-calendar
      #calendar
      [minDate]="minDate"
      [maxDate]="maxDate"
      [selected]="selectedRangeValueSubject | async"
      [startAt]="startDate"
      (selectedChange)="selectedChange($event)"
      class="fixed-height"
    >
    </mat-calendar>
    <hr class="primary-divider my-2" />
    <div class="d-flex flex-column">
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        (click)="setRange(0)"
      >
        Today
      </button>
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        (click)="setRange(3)"
      >
        Last 3 days
      </button>
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        (click)="setRange(7)"
      >
        Last 7 days
      </button>
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        (click)="setRange(30)"
      >
        Last 30 days
      </button>
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        id="previous-btn"
        [disabled]="isPreviousBtnDisabled$ | async"
        (click)="previousMonth()"
      >
        Previous month
      </button>
      <button
        type="button"
        class="mx-2 my-2"
        mat-stroked-button
        id="next-btn"
        [disabled]="isNextBtnDisabled$ | async"
        (click)="nextMonth()"
      >
        Next month
      </button>
    </div>
  </div>
</ng-template>
